/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_Generate_BulletsInputs */

const en_resume_editor_generate_bullets = /** @type {(inputs: Resume_Editor_Generate_BulletsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate Bullets`)
};

const de_resume_editor_generate_bullets = /** @type {(inputs: Resume_Editor_Generate_BulletsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stichpunkte generieren`)
};

const fr_resume_editor_generate_bullets = /** @type {(inputs: Resume_Editor_Generate_BulletsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generer des puces`)
};

const es_resume_editor_generate_bullets = /** @type {(inputs: Resume_Editor_Generate_BulletsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar puntos`)
};

const it_resume_editor_generate_bullets = /** @type {(inputs: Resume_Editor_Generate_BulletsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera punti elenco`)
};

const nl_resume_editor_generate_bullets = /** @type {(inputs: Resume_Editor_Generate_BulletsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genereer opsommingstekens`)
};

const pl_resume_editor_generate_bullets = /** @type {(inputs: Resume_Editor_Generate_BulletsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generuj punkty`)
};

const fi_resume_editor_generate_bullets = /** @type {(inputs: Resume_Editor_Generate_BulletsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luo luettelokohdat`)
};

const da_resume_editor_generate_bullets = /** @type {(inputs: Resume_Editor_Generate_BulletsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generer punkter`)
};

const sv_resume_editor_generate_bullets = /** @type {(inputs: Resume_Editor_Generate_BulletsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generera punkter`)
};

/**
* | output |
* | --- |
* | "Generate Bullets" |
*
* @param {Resume_Editor_Generate_BulletsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_generate_bullets = /** @type {((inputs?: Resume_Editor_Generate_BulletsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_Generate_BulletsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_generate_bullets(inputs)
	if (locale === "fr") return fr_resume_editor_generate_bullets(inputs)
	if (locale === "es") return es_resume_editor_generate_bullets(inputs)
	if (locale === "it") return it_resume_editor_generate_bullets(inputs)
	if (locale === "nl") return nl_resume_editor_generate_bullets(inputs)
	if (locale === "pl") return pl_resume_editor_generate_bullets(inputs)
	if (locale === "fi") return fi_resume_editor_generate_bullets(inputs)
	if (locale === "da") return da_resume_editor_generate_bullets(inputs)
	if (locale === "sv") return sv_resume_editor_generate_bullets(inputs)
	return en_resume_editor_generate_bullets(inputs)
});